import { graphql } from 'react-relay';

import { FormulaSetWindowPaginator_query$key } from '../../../relay/__generated__/FormulaSetWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const FormulaSetWindowPaginator_query = graphql`
  fragment FormulaSetWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: FormulaSetFilter }
    order: { type: FormulaSetOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "FormulaSetWindowPaginatorRefreshQuery") {
    formulaSets(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      ...FormulaSetConnectionDataTable_formulaSetConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<FormulaSetWindowPaginator_query$key>, 'fragment'>;

const FormulaSetWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={FormulaSetWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.formulaSets.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default FormulaSetWindowPaginator;
